export const PREVENTIVE_SERVICES = [
  {
    id: 'PM-001',
    vehicleNumber: 'DXB-T-4021',
    vehicleType: 'Fuel Tanker',
    serviceType: 'Engine Service',
    lastServiceDate: '2026-03-15',
    nextDueDate: '2026-09-15',
    intervalDays: 180,
    odometerKm: 142800,
    nextDueKm: 150000,
    daysRemaining: 95,
    kmRemaining: 7200,
    progress: 68,
    status: 'on_track',
  },
  {
    id: 'PM-002',
    vehicleNumber: 'SHJ-C-8810',
    vehicleType: 'Chemical Tanker',
    serviceType: 'Gearbox Overhaul',
    lastServiceDate: '2025-11-20',
    nextDueDate: '2026-07-20',
    intervalDays: 240,
    odometerKm: 198400,
    nextDueKm: 200000,
    daysRemaining: 38,
    kmRemaining: 1600,
    progress: 88,
    status: 'due_soon',
  },
  {
    id: 'PM-003',
    vehicleNumber: 'AUH-B-3340',
    vehicleType: 'Bitumen Tanker',
    serviceType: 'Suspension Tuning',
    lastServiceDate: '2026-01-10',
    nextDueDate: '2026-07-10',
    intervalDays: 180,
    odometerKm: 87600,
    nextDueKm: 95000,
    daysRemaining: 28,
    kmRemaining: 7400,
    progress: 72,
    status: 'due_soon',
  },
  {
    id: 'PM-004',
    vehicleNumber: 'DXB-F-2208',
    vehicleType: 'Fuel Tanker',
    serviceType: 'Brake System Override',
    lastServiceDate: '2026-04-01',
    nextDueDate: '2026-06-25',
    intervalDays: 90,
    odometerKm: 121200,
    nextDueKm: 125000,
    daysRemaining: 13,
    kmRemaining: 3800,
    progress: 92,
    status: 'critical',
  },
  {
    id: 'PM-005',
    vehicleNumber: 'RUW-G-7721',
    vehicleType: 'Fuel Tanker',
    serviceType: 'Engine Service',
    lastServiceDate: '2026-02-28',
    nextDueDate: '2026-08-28',
    intervalDays: 180,
    odometerKm: 65400,
    nextDueKm: 80000,
    daysRemaining: 77,
    kmRemaining: 14600,
    progress: 45,
    status: 'on_track',
  },
  {
    id: 'PM-006',
    vehicleNumber: 'SHJ-T-9901',
    vehicleType: 'Water Tanker',
    serviceType: 'Brake System Override',
    lastServiceDate: '2026-05-01',
    nextDueDate: '2026-08-01',
    intervalDays: 90,
    odometerKm: 44200,
    nextDueKm: 50000,
    daysRemaining: 50,
    kmRemaining: 5800,
    progress: 55,
    status: 'on_track',
  },
];

export const SERVICE_STATUS = {
  on_track: { label: 'On Track', className: 'bg-emerald-500/15 text-emerald-700 ring-emerald-500/30' },
  due_soon: { label: 'Due Soon', className: 'bg-amber-500/15 text-amber-700 ring-amber-500/30' },
  critical: { label: 'Critical', className: 'bg-red-500/15 text-red-700 ring-red-500/30 animate-pulse' },
};

export const REPAIR_STATUS = {
  under_inspection: {
    label: 'Under Inspection',
    className: 'bg-logi-accent/100/15 text-blue-700 ring-blue-500/30',
  },
  waiting_parts: {
    label: 'Waiting for Parts',
    className: 'bg-amber-500/15 text-amber-700 ring-amber-500/30',
  },
  in_progress: {
    label: 'In Progress',
    className: 'bg-violet-500/15 text-logi-accent ring-logi-accent/30',
  },
  completed: {
    label: 'Completed',
    className: 'bg-emerald-500/15 text-emerald-700 ring-emerald-500/30',
  },
};

export const BREAKDOWN_INCIDENTS = [
  {
    id: 'BRK-001',
    priority: 'critical',
    vehicleNumber: 'AUH-B-3340',
    reportedIssue: 'Valve leakage on Bitumen Tanker — hazardous drip detected',
    garage: 'Al Quoz Heavy Workshop',
    repairStatus: 'under_inspection',
    costAed: 4200,
    reportedAt: '12 Jun 2026 · 08:15 AM',
  },
  {
    id: 'BRK-002',
    priority: 'high',
    vehicleNumber: 'DXB-F-2208',
    reportedIssue: 'Air brake compressor failure — vehicle grounded on E311',
    garage: 'Dubai Industrial City Garage',
    repairStatus: 'waiting_parts',
    costAed: 8750,
    reportedAt: '11 Jun 2026 · 04:40 PM',
  },
  {
    id: 'BRK-003',
    priority: 'high',
    vehicleNumber: 'SHJ-C-8810',
    reportedIssue: 'Rear axle vibration above 80 km/h — suspension suspected',
    garage: 'Sharjah National Workshop',
    repairStatus: 'in_progress',
    costAed: 12300,
    reportedAt: '10 Jun 2026 · 11:20 AM',
  },
  {
    id: 'BRK-004',
    priority: 'medium',
    vehicleNumber: 'DXB-G-4455',
    reportedIssue: 'Fuel gauge sensor malfunction — telematics offline',
    garage: 'Jebel Ali Fleet Service Center',
    repairStatus: 'completed',
    costAed: 1850,
    reportedAt: '09 Jun 2026 · 02:00 PM',
  },
  {
    id: 'BRK-005',
    priority: 'critical',
    vehicleNumber: 'AUH-L-6688',
    reportedIssue: 'LPG vapor recovery unit seal failure — ADQCC notified',
    garage: 'Mussafah Hazmat Workshop',
    repairStatus: 'waiting_parts',
    costAed: 15600,
    reportedAt: '12 Jun 2026 · 06:30 AM',
  },
];

export const SERVICE_TYPE_ICONS = {
  'Engine Service': 'engine',
  'Gearbox Overhaul': 'cog',
  'Suspension Tuning': 'settings',
  'Brake System Override': 'disc',
};
